<template>
  <div>
    <h6>Belge Say.: {{ BELGESAYISI }}</h6>
    <vs-divider style="margin: 0px !important"></vs-divider>
    Tutar: {{ MALHIZMETBEDELI }}
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      BELGESAYISI: "",
      MALHIZMETBEDELI: 0.0,
    };
  },
  methods: {
    gelenData() {
      this.BELGESAYISI = this.params.data.BELGESAYISI;
      this.MALHIZMETBEDELI = this.currencyFormatter(
        this.params.data.MALHIZMETBEDELI,
        "₺"
      );
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
